<template>
    <div class="items-menu-container">
        <div class="items-menu-list">
            <WaitingBlock v-if="isLoading" />
            <slot v-else name="Content"></slot>
        </div>
        <div class="actions" v-if="!noAction">
            <slot name="Actions"></slot>
        </div>
    </div>
</template>

<script>

    import WaitingBlock from'@/components/common/WaitingBlock'
    export default {
        name: "ItemMenuList",
        components: {
            WaitingBlock
        },
        props:
        {
            noAction: {type:Boolean, default:false},
            isLoading: Boolean
        }
    }
</script>

<style scoped>

</style>
